import React from 'react';

import { ReactComponent } from './you-are-here-icon.svg';

function YouAreHereIcon({ size }: { size?: string }) {
  return <ReactComponent width={size} height={size} />;
}

export default YouAreHereIcon;
